"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSettingsSnapshot = void 0;
const react_1 = require("react");
const osrs_sdk_1 = require("osrs-sdk");
function useSettingsSnapshot(selector = (snapshot) => snapshot) {
    const snapshot = (0, react_1.useSyncExternalStore)(osrs_sdk_1.Settings.subscribe, osrs_sdk_1.Settings.getSnapshot, osrs_sdk_1.Settings.getSnapshot);
    return selector(snapshot);
}
exports.useSettingsSnapshot = useSettingsSnapshot;
